import { render } from "./spinner.vue?vue&type=template&id=262abbcd&scoped=true&ts=true"
import script from "./spinner.vue?vue&type=script&lang=ts"
export * from "./spinner.vue?vue&type=script&lang=ts"

import "./spinner.vue?vue&type=style&index=0&id=262abbcd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-262abbcd"]])

export default __exports__